/**
 * 时区偏移量
 * @returns string
 */
export var getTimezoneOffset = function () {
    var offset = new Date().getTimezoneOffset();
    var operator = offset >= 0 ? '-' : '+';
    var _offset = Math.abs(offset);
    var h = Math.floor(_offset / 60);
    var m = Math.floor(_offset % 60);
    var _h = h < 10 ? "0" + h : h;
    var _m = m < 10 ? "0" + m : m;
    return "" + operator + _h + ":" + _m;
};
/**
 * 获取 UTC 时间+时区偏移量
 * @param {number}} now
 * @returns string
 */
export var getUTCTime = function (now) {
    var utc = new Date(now).toISOString();
    return utc.replace('Z', getTimezoneOffset());
};
